export const ENDPOINTS = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  GET_USER_DATA: (userId: number) => `companies/user/${userId}`,
  CHECK_VIRGIN: 'virgin',
  PASSWORD_RESET: 'password',
} as const;
